<template lang="pug">
    div.criterion-taglist(style="max-width: 300px")
        div.criterion-tag.l-flex-row.l-align-center(
            v-for="(tag, tKey) in tags"
            :key="tKey"
            v-if="showAllTags || tKey < 5"
            :title="tag.label"
            :class="{'is-highlighted': queryTypeFilter === 'tags.label' && tag.label.includes(queryFilter) }"
            @click="filterBySelectedTag(tag.label)"
        )
            span.label {{ tag.label }}
        div.tag-more(@click="toggleShowTags()" v-if="tags.length > 5") {{showAllTags? 'less' : 'more'}}
</template>

<script>
export default {
    name: 'MonitoringTags',

    props: {
        tags: { type: Array, required: true },
        queryFilter: { type: String, required: false },
        queryTypeFilter: { type: String, required: false }
    },

    data() {
        return {
            showAllTags: false
        }
    },

    methods: {
        toggleShowTags() {
            this.showAllTags = !this.showAllTags
        },

        filterBySelectedTag(label) {
            this.$emit('filterBySelectedTag', label)
        }
    }
}
</script>
